import React from 'react';

export interface ProjectVersionContextProps {
  isFetchingProjectVersion?: boolean;
  projectVersionList: {
    name: string;
    projectId: string;
    id: string;
  }[];
  fetchProjectVersion: (projectId: string) => void;
}

const initialValues: ProjectVersionContextProps = {
  isFetchingProjectVersion: false,
  projectVersionList: [],
  fetchProjectVersion: () => undefined,
};

export const ProjectVersionContext =
  React.createContext<ProjectVersionContextProps>(initialValues);
